import { Chip } from '@mui/material';

import type { CashLogProvenance as Provenance } from '@/types/machine';

/** `provenance` enum → human label. */
const LABEL: Record<Provenance, string> = {
  machine_reported: 'Machine',
  heartbeat_inferred: 'Inferred',
  manual: 'Manual',
};

/**
 * Provenance chip for cash-log tables. Renders the native Bitstop/MUI `Chip`
 * (outlined, neutral) rather than a custom indicator.
 */
const CashLogProvenance = ({ value }: { value: Provenance | string }) => (
  <Chip size="small" variant="outlined" label={LABEL[value as Provenance] ?? value} />
);

export default CashLogProvenance;
